"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledErrorMessage = exports.StyledDropdownWrapper = exports.StyledDropdownLabel = exports.StyledDropdownHeader = exports.ListItem = exports.DropDownListContainer = exports.DropDownList = exports.DropDownContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("../../shared");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledDropdownWrapper = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledDropdownWrapper",
  componentId: "sc-bw4l9p-0"
})(["width:", ";outline:none;:focus{.dropdown-header{", ";", ";}}"], ({
  width,
  isDefault
}) => width ? width : isDefault ? `346px` : `auto`, ({
  error
}) => error ? `box-shadow: inset 0 -1px 0 ${_shared.theme.palette.ui.cta.red}` : `box-shadow: inset 0 -1px 0 ${_shared.theme.palette.ui.cta.yellow};`, ({
  disabled
}) => disabled && `box-shadow: inset 0 -1px 0 ${_shared.theme.palette.ui.neutral.grey7};`);

exports.StyledDropdownWrapper = StyledDropdownWrapper;
const DropDownContainer = (0, _styledComponents.default)('div').withConfig({
  displayName: "styles__DropDownContainer",
  componentId: "sc-bw4l9p-1"
})(["display:inline-block;width:", ";position:relative;font-family:", ";", ";.icon{position:absolute;", " right:0;transform-origin:50% 50%;transition:all 0.2s ease;", ";svg{", ";}}.rotate0{transform:translateY(3px);}.rotate180{transform:rotate(-180deg);}.label-row{display:flex;align-items:center;justify-content:space-between;.no-op-icon{transition:all 0.2s ease;}}"], ({
  width,
  isDefault
}) => width ? width : isDefault ? `346px` : `auto`, _shared.theme.typography.caption.fontFamily, ({
  disabled
}) => disabled && `pointer-events: none`, ({
  isDefault,
  isSelected
}) => isDefault && `top: ${isSelected ? '22px' : '12px'};`, props => props.isDefault ? `position: absolute;
      right: 0;` : `position: relative;`, ({
  disabled
}) => disabled && `fill: ${_shared.theme.palette.ui.neutral.grey7}`);
exports.DropDownContainer = DropDownContainer;
const StyledDropdownLabel = (0, _styledComponents.default)('div').withConfig({
  displayName: "styles__StyledDropdownLabel",
  componentId: "sc-bw4l9p-2"
})([".dd-lable{", ";color:", ";", "}"], _shared.theme.typography.h6.css, _shared.theme.palette.brand.primary.gray, ({
  disabled
}) => disabled && `
            color: ${_shared.theme.palette.ui.neutral.grey7};
            pointer-events: none;
    `);
exports.StyledDropdownLabel = StyledDropdownLabel;
const StyledDropdownHeader = (0, _styledComponents.default)('div').withConfig({
  displayName: "styles__StyledDropdownHeader",
  componentId: "sc-bw4l9p-3"
})(["text-align:center;align-items:center;", ";", ";", ";display:flex;justify-content:center;padding:8px 0 16px 0;box-sizing:border-box;:focus{box-shadow:inset 0px -1px 0px ", ";}.content-wrapper{flex:1;display:flex;justify-content:left;align-items:baseline;label{display:inline-block;", ";text-align:left;color:", ";}.option-label{font-family:", ";font-size:13px;line-height:16px;letter-spacing:0.02em;", ";}svg{path{fill:", ";}}}"], props => props.isDefault ? `box-shadow: inset 0 -1px 0 ${_shared.theme.palette.brand.primary.charcoal}` : `box-shadow:none`, ({
  errorState
}) => errorState && `box-shadow: inset 0 -1px 0 ${_shared.theme.palette.ui.cta.red}`, ({
  disabled
}) => disabled && `
      box-shadow: inset 0 -1px 0 ${_shared.theme.palette.ui.neutral.grey7};
      pointer-events: none;
    `, _shared.theme.palette.ui.cta.yellow, props => props.isDefault ? `width:100%` : `width:auto;margin-right:10px`, _shared.theme.palette.brand.primary.charcoal, _shared.theme.typography.subtitle1.fontFamily, ({
  disabled
}) => disabled && `color: ${_shared.theme.palette.ui.neutral.grey7}`, ({
  disabled
}) => disabled ? _shared.theme.palette.ui.neutral.grey7 : '#2b2b2b');
exports.StyledDropdownHeader = StyledDropdownHeader;
const DropDownListContainer = (0, _styledComponents.default)('div').withConfig({
  displayName: "styles__DropDownListContainer",
  componentId: "sc-bw4l9p-4"
})(["position:absolute;font-size:", ";line-height:", ";letter-spacing:", ";cursor:pointer;width:", ";z-index:3;", ";"], _shared.theme.typography.h6.fontSize, _shared.theme.typography.h6.lineHeight, _shared.theme.typography.h6.letterSpacing, ({
  isDefault
}) => isDefault ? 'inherit' : '200px', ({
  isDefault,
  placement
}) => !isDefault && placement ? placement === 'right' ? 'right: 0px;' : placement === 'left' ? 'left: 0px' : '' : '');
exports.DropDownListContainer = DropDownListContainer;
const DropDownList = (0, _styledComponents.default)('ul').withConfig({
  displayName: "styles__DropDownList",
  componentId: "sc-bw4l9p-5"
})(["::-webkit-scrollbar{-webkit-appearance:none;width:4px;}::-webkit-scrollbar-thumb{border-radius:10px;background-color:", ";box-shadow:0 0 0.0625rem rgba(255,255,255,0.5);}padding:0;margin:0;max-height:190px;overflow-y:auto;box-sizing:border-box;", ";border-radius:4px;background:", ";.active{background:", ";}.selected{background:", ";}"], _shared.theme.palette.brand.primary.gray, props => props.isDefault ? ` box-shadow: 0 5px 20px rgba(115, 127, 143, 0.1);` : ` border: 1px solid ${_shared.theme.palette.ui.neutral.grey2};
			box-shadow: 0px 6px 16px rgba(115, 127, 143, 0.16);
			`, _shared.theme.palette.brand.primary.white, _shared.theme.palette.ui.neutral.grey5, _shared.theme.palette.ui.neutral.grey5);
exports.DropDownList = DropDownList;
const ListItem = (0, _styledComponents.default)('li').withConfig({
  displayName: "styles__ListItem",
  componentId: "sc-bw4l9p-6"
})(["text-align:left;list-style:none;cursor:pointer;color:", ";padding:14px 20px 14px 24px;&:hover{background-color:", ";}:first-child{padding-top:14px;padding-bottom:14px;}:last-child{padding-top:14px;padding-bottom:14px;}"], _shared.theme.palette.brand.primary.charcoal, _shared.theme.palette.ui.neutral.grey5);
exports.ListItem = ListItem;

const StyledErrorMessage = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledErrorMessage",
  componentId: "sc-bw4l9p-7"
})(["", ";color:", ";margin:4px 0px 0px 1px;"], _shared.theme.typography.caption.css, _shared.theme.palette.ui.cta.red);

exports.StyledErrorMessage = StyledErrorMessage;